const primaryConfig = {
	// Email
	primaryContactID: 5,
	// Primary
	primaryAddressID: 4
};

export default primaryConfig;
